<!-- 此component用來Alert視窗的顯示 -->
<template id="alert">
  <transition name="fade">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container"> 
          <div class="modal-header">
            <slot name="header">
              <div>
                <span>{{title}}</span>
              </div>
            </slot>
          </div>

          <div v-if="this.$store.state.nowDepartmentStatus === 1" >
            <div class="modal-body">
              <slot name="body">
                <span class="modal-content">{{content}}</span>
                <span class="modal-warning">{{warning}}</span>
              </slot>
            </div>
            <button class="delete-btn" @click="$emit('delete')">刪除</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.nowDepartmentStatus === 2">
            <div class="modal-body">
              <slot name="body">
                <div v-for="(input, index) in inputs" :key="input">
                  <span class="model-input-title">{{input}}</span>
                  <input v-show="index === 0" class="model-input" v-bind:placeholder="placeholder[index]" 
                          @input="$emit('change-dep-name', $event.target.value)">
                  <el-select v-show="index === 1" v-model="depId" v-bind:placeholder="placeholder[index]"
                          class="alert-filter-select" @change="$emit('change-dep-id', $event)">
			              <el-option v-for="dep in depList" :key="dep.id" :label="dep.title" :value="dep.id">
				            </el-option>
			            </el-select>
                </div>
              </slot>
            </div>
            <button class="add-btn" @click="$emit('add')">新增</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.nowCategoryStatus === 1" >
            <div class="modal-body">
              <slot name="body">
                <span class="modal-content">{{content}}</span>
                <span class="modal-warning">{{warning}}</span>
              </slot>
            </div>
            <button class="delete-btn" @click="$emit('delete')">刪除</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.nowCategoryStatus === 2">
            <div class="modal-body">
              <slot name="body">
                <div v-for="(input, index) in inputs" :key="input">
                  <span class="model-input-title">{{input}}</span>
                  <input v-show="index === 0" class="model-input" v-bind:placeholder="placeholder[index]" v-bind:parent-msg="inputMaster"  @input="$emit('changeMaster', $event.target.value)">
                  <input v-show="index === 1" class="model-input" v-bind:placeholder="placeholder[index]" v-bind:parent-msg="inputSecondary"  @input="$emit('changeSecondary', $event.target.value)">
                </div>
              </slot>
            </div>
            <button class="add-btn" @click="$emit('add')">新增</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.nowMemberListStatus === 1" >
            <div class="modal-body">
              <slot name="body">
                <span class="modal-content">{{content}}</span>
              </slot>
            </div>
            <button class="delete-btn" @click="$emit('delete')">刪除</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.nowMemberListStatus === 2">
            <div class="modal-body">
              <slot name="body">
                <div v-for="(input, index) in inputs" :key="input">
                  <span class="model-input-title">{{input}}</span>
                  <input v-show="index === 0" class="model-input" v-bind:placeholder="placeholder[index]" v-bind:parent-msg="inputMaster"  @input="$emit('changeMaster', $event.target.value)">
                </div>
              </slot>
            </div>
            <button class="add-btn" @click="$emit('add')">新增</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.accountList.status === 1" >
            <div class="modal-body">
              <slot name="body">
                <span class="modal-content">{{content}}</span>
                <span class="modal-warning">{{warning}}</span>
              </slot>
            </div>
            <button class="delete-btn" @click="$emit('delete')">刪除</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

          <div v-else-if="this.$store.state.accountList.status === 2 || this.$store.state.accountList.status === 3">
            <div class="modal-body">
              <slot name="body">
                <div v-if="inputs && placeholder">
                  <span class="model-input-title">{{inputs[0]}}</span>
                  <input v-if="this.$store.state.accountList.status === 2" 
                         class="model-input" 
                         v-bind:placeholder="placeholder[0]" 
                         v-bind:parent-msg="inputMaster"  
                         @input="$emit('addName', $event.target.value)"
                  >
                  <input type="text" v-else-if="this.$store.state.accountList.status === 3" 
                         class="model-input"  
                         v-model="inputMaster"
                         :disabled="true"
                  >
                  <span class="model-input-title">{{inputs[1]}}</span>
                  <el-select v-model="department.selected" 
                             class="alert-filter-select" 
                             @change="$emit('selectDep', $event)">
			              <el-option v-for="selectedFilter in department.selectedFilters" 
			                    :key="selectedFilter.id" 
			                    :label="selectedFilter.text" 
			                    :value="selectedFilter.value">{{ selectedFilter.text }}
                    </el-option>
			            </el-select>

                  <span class="model-input-title">{{inputs[2]}}</span>
                  <el-select v-model="level.selected" 
                             class="alert-filter-select" 
                             @change="$emit('selectLevel', $event)">
			              <el-option v-for="selectedFilter in level.selectedFilters" 
			                    :key="selectedFilter.value" 
			                    :label="selectedFilter.text" 
			                    :value="selectedFilter.value">{{ selectedFilter.text }}
                    </el-option>
			            </el-select>

                  <span class="model-input-title">{{inputs[3]}}</span>
                  <el-select v-model="admin.selected" 
                             class="alert-filter-select" 
                             @change="$emit('selectAdmin', $event)">
			              <el-option v-for="selectedFilter in admin.selectedFilters" 
			                    :key="selectedFilter.value" 
			                    :label="selectedFilter.text" 
			                    :value="selectedFilter.value">{{ selectedFilter.text }}
                    </el-option>
			            </el-select>
                </div>
              </slot>
            </div>
            <button v-if="this.$store.state.accountList.status === 2" class="add-btn" @click="$emit('add')">新增</button>
            <button v-else-if="this.$store.state.accountList.status === 3" class="add-btn" @click="$emit('change')">修改</button>
            <button class="cancel-btn" @click="$emit('close')">取消</button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: String,
    content: String,
    warning: String,
    inputs: Array,
    placeholder: Array,
    inputMaster: String,
    inputSecondary: String,
    department: {
      selected: Number,
      selectedFilters: Array,
      value: Number
    },
    level: {
      selected: Number,
      selectedFilters: Array,
      value: Number
    },
    admin: {
      selected: Number,
      selectedFilters: Array,
      value: Number
    },
    depList: Array,
  },
  data: function() {
    return {
      depId: null,
    }
  },
  beforeCreate() {
    
  },
  created() {
   
  },
  mounted() {
    
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
$white: #ffffff;
$font-color: #222222;
$border-color: #EEEEEE;
$button-color: #2E90F4;

.modal-mask {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  position: relative;
  max-width: 40%;
  margin: -10% auto 0 auto;
  padding: 18px 10px;
  background-color: $white;
  transition: all .3s ease;
  overflow: hidden;
}

.modal-header {
  text-align: left;
  border-bottom: 1px solid $border-color;
  padding-bottom: 12px;
  span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 12px;
    font-size: 18px;
    color: #222;
    line-height: 24px;
  }
}

.modal-body {
  text-align: left;
  padding-top: 18px;
  padding-bottom: 100px;
  width: 100%;
  .modal-content {
    display: float;
    float: left;
    text-decoration: none;
    font-size: 16px;
    margin-left: 13px;
    line-height: 24px;
  }
  .modal-warning {
    display: block;
    text-decoration: none;
    margin-top: 35px;
    font-size: 16px;
    margin-left: 13px;
    line-height: 24px;
    color : #F5A623;
  }
  .model-input-title {
    font-size: 16px;
    margin-left: 12px;
    color: #626874;
    line-height: 24px;
    float: left;
    display: float;
    width: 100%;
  }
  .model-input {
    background: $white;
    border: 1px solid $border-color;
    border-radius: 2px;
    height: 48px;
    display: inline-block;
    margin: 10px auto 10px auto;
    width: 98%;
    font-size: 16px;
    color: #222222;
    line-height: 24px;
    padding-left: 10px;
  }

  .alert-filter-select {
    width: 38vw;
    text-align: center;
    top: 10px;
    margin-bottom: 20px;

    .el-input__inner {
      border-color: #EEE;
      background-color: $white;
      border-radius: 2px;
      font-size: 16px;
      color: $font-color;
      line-height: 44px;
      margin-top: 9px;	
    }

    .el-input__icon {
      width: 40px;
      margin-top: 4px;
      color: #626874;
    }

    .el-input__suffix {
      &:before{
        content: '';
        position: absolute;
        left: 0;
        height: 32px;
        width: 1px;
        background-color: rgba(151, 151, 151, .35);
        margin-top: 7px;
      }
    }

    .el-icon-arrow-up {
      &:before {
        color: #a7a7a7;
        content: '\25B2';
      }
    }
  }
}

.el-select-dropdown {
      z-index: 9999 !important;
    }
    
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.cancel-btn {
  width: 76px;
  height: 36px;
  cursor: pointer;
  background: $button-color;
  border: 1px solid $button-color;
  border-radius: 2px;
  color: $white;
  float: right;
  margin-right: 2%;
  &:hover {
    background: #42A0FF;
  }
}

.cancel-btn:focus {
  //outline: none;
}

.delete-btn {
  width: 76px;
  height: 36px;
  cursor: pointer;
  background: $white;
  border: 1px solid $button-color;
  border-radius: 2px;
  color: $button-color;
  float: right;
  &:hover {
    opacity: 0.8; 
  }
}

.delete-btn:focus {
  //outline: none;
}

.add-btn {
  width: 76px;
  height: 36px;
  cursor: pointer;
  background: $white;
  border: 1px solid $button-color;
  border-radius: 2px;
  color: $button-color;
  float: right;
  &:hover {
    color: #42A0FF;
  }
}

.add-btn:focus {
  //outline: none;
}
</style>



// WEBPACK FOOTER //
// Alert.vue?d0b43436